import React from 'react';
import { motion } from 'framer-motion';
import { CONFIG } from '../config/variables';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiMic } = FiIcons;

const FinalCTA = () => {
  const scrollToPayment = () => {
    const element = document.getElementById('payment');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleFeedbackClick = () => {
    if (CONFIG.FEEDBACK_RECORDING_URL !== "TOBEUPDATED") {
      window.open(CONFIG.FEEDBACK_RECORDING_URL, '_blank');
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-900/30 to-purple-900/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl lg:text-5xl font-bold text-white mb-8">
            Build a landing page that works as hard as you do.
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.button
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              onClick={scrollToPayment}
              className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-xl hover:shadow-2xl transform hover:scale-105 flex items-center justify-center gap-2"
            >
              Start My Landing Page Enquiry
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </motion.button>
            {CONFIG.PREVIEW_MODE && (
              <motion.button
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                onClick={handleFeedbackClick}
                disabled={CONFIG.FEEDBACK_RECORDING_URL === "TOBEUPDATED"}
                className="w-full sm:w-auto bg-white/10 backdrop-blur-sm border border-white/30 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/20 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <SafeIcon icon={FiMic} className="w-5 h-5" />
                Record Feedback
              </motion.button>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;